// ── SignaturePreview ─────────────────────────────────────────────────────────
// Muestra una firma de cuenta como se va a ver EN EL CORREO, no como se ve en
// la app. Dos decisiones que no son negociables acá:
//
// 1. Fondo blanco fijo, no `var(--evo-bg-*)`. El cuerpo de un correo es blanco
//    siempre (REGLA de UI #1). Una firma con texto oscuro previsualizada sobre
//    el tema oscuro de Evo Hub se ve perfecta y llega ilegible.
// 2. El HTML pasa por DOMPurify. La firma es un campo de texto que un usuario
//    escribe y que después se renderiza con dangerouslySetInnerHTML — en una
//    cuenta con varios usuarios, lo que escribe uno corre en el navegador del
//    otro. Al correo sale sin sanear a propósito: ahí el cliente de correo ya
//    hace su propio filtrado, y sanear de más rompe firmas legítimas.
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import { isHtmlSignature } from '../../lib/signature.js';

interface SignaturePreviewProps {
  value: string;
  /** Oculta el rótulo cuando el contenedor ya dice qué es esto. */
  hideLabel?: boolean;
}

export function SignaturePreview({ value, hideLabel = false }: SignaturePreviewProps) {
  const { t } = useTranslation();
  if (!value.trim()) return null;

  const isHtml = isHtmlSignature(value);

  return (
    <div>
      {!hideLabel && (
        <div
          style={{
            fontSize: 'var(--evo-fs-caption)',
            fontFamily: 'var(--evo-font)',
            color: 'var(--evo-fg-3)',
            marginBottom: 'var(--evo-space-1)',
          }}
        >
          {isHtml ? t('settings.accounts.signature_preview_html') : t('settings.accounts.signature_preview_text')}
        </div>
      )}

      <div
        style={{
          background: '#FFFFFF',
          border: '1px solid var(--evo-stroke)',
          borderRadius: 'var(--evo-r)',
          padding: 'var(--evo-space-3)',
          overflowX: 'auto',
        }}
      >
        {isHtml ? (
          <div
            style={{ color: '#111111', fontSize: '13px', lineHeight: 1.5 }}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }}
          />
        ) : (
          <div
            style={{
              color: '#777777',
              fontSize: '12px',
              lineHeight: 1.5,
              whiteSpace: 'pre-wrap',
              borderTop: '1px solid #DDDDDD',
              paddingTop: '8px',
            }}
          >
            {'-- \n'}
            {value}
          </div>
        )}
      </div>
    </div>
  );
}
